/*! Copyright 2026 Fonticons, Inc. - https://webawesome.com/license */

// _bundle_/src/events/options-error.ts
var WaOptionsErrorEvent = class extends Event {
  constructor(detail) {
    super("wa-options-error", { bubbles: true, cancelable: false, composed: true });
    this.detail = detail;
  }
};

export {
  WaOptionsErrorEvent
};
